import React from 'react';
import {RsnButton, RsnDialog} from '~/library/ui-kit';

export function PaymentRestrictionsModal() {
    return (
        <RsnDialog.Window placement='center'>
            <RsnDialog.CenteredHeader>Restrictions</RsnDialog.CenteredHeader>
            <RsnDialog.Body>
                <div className='fv-text-m-regular flex flex-col gap-1 rounded-[10px] bg-[#f5f5f5] p-5 text-left text-neutral-90'>
                    <div>
                        As of the 25th of March, 2022, our partner payment provider suspends bank operations for
                        citizens and residents of Russia, Belarus and Ukraine. Top-ups via cards are not available too.
                        <br />
                        <strong className={'fv-text-m-bold'}>
                            Cryptocurrency services would be still available with some limitations.
                        </strong>
                    </div>
                    <div>
                        If you would like to avoid all limitations, please provide your citizenship or residency and
                        proof of address in another country. Please write to
                        <a href='mailto:support@raison.app' className='text-primary-30'>
                            {' '}
                            support@raison.app
                        </a>{' '}
                        in this regard.
                    </div>
                    <div>
                        We are currently working on bringing the functionality back, and it will become available in the
                        near future.
                    </div>
                </div>
            </RsnDialog.Body>
            <RsnDialog.Footer>
                <RsnButton.Alike intent='secondary' as={RsnDialog.CloseTrigger}>
                    I got it
                </RsnButton.Alike>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}
